// necessary for vs code autocompletion of json prisma types to work
// don't delete
import '@signupsoftware/server/prisma-types.js'
import { createRoot } from 'react-dom/client'

// import '@unimpaired/react/style.css' // This allows our style library to work
import './index.css' // This allows tailwind to work
import { App } from './App'

import * as Sentry from '@sentry/react'
import { SENTRY_CONFIG } from './config/sentry.config'

Sentry.init(SENTRY_CONFIG)

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(<App />)
